import { Component, Input, OnInit } from '@angular/core';

import { ViewCell } from '../../../components/ng2-smart-table';

@Component({
  selector: 'app-mobile-search',
  templateUrl: './mobile-search.component.html',
  styleUrls: ['./mobile-search.component.scss']
})
export class MobileSearchComponent implements ViewCell, OnInit {
	renderValue: string;
	searchId: string;

	@Input() value: string | number;
	@Input() rowData: any;

	constructor() { }

	ngOnInit() {
	}

	mobileSearch(mobile) {
		let searchBox = (<HTMLInputElement>document.getElementById(this.searchId))
		searchBox.value = mobile;
		searchBox.dispatchEvent(new KeyboardEvent('keydown', {'key': 'Enter'}));
	}

	setRenderValue(value) {
		this.renderValue = value;
	}

	setSearchId(value) {
		this.searchId = value;		
	}

	isNumber(val) {
		return /^\d+$/.test(val);
	}
}
